// Letris — duel WS client
const DEFAULT_URL = 'ws://localhost:8787';
const URL_RAW = (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env.VITE_WS_URL) || DEFAULT_URL;

function resolveWsUrl(raw) {
  if (!raw) return DEFAULT_URL;
  if (raw.startsWith('ws://') || raw.startsWith('wss://')) return raw;
  if (typeof window === 'undefined' || !window.location) return raw;
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const path = raw.startsWith('/') ? raw : '/' + raw;
  return `${proto}//${window.location.host}${path}`;
}
const URL = resolveWsUrl(URL_RAW);

export class DuelConn {
  constructor() {
    this.ws = null;
    this.handlers = {};
    this.connected = false;
  }
  connect(name, extra = {}) {
    return new Promise((resolve, reject) => {
      let ws;
      try { ws = new WebSocket(URL); } catch (e) { reject(e); return; }
      const failTimer = setTimeout(() => { reject(new Error('WS timeout')); ws.close(); }, 7000);
      ws.onopen = () => {
        clearTimeout(failTimer);
        this.connected = true;
        this.send({ t: 'hello', name, ...extra });
        resolve();
      };
      ws.onerror = (e) => { clearTimeout(failTimer); reject(e); };
      ws.onclose = () => { this.connected = false; this.handlers.close?.(); };
      ws.onmessage = (ev) => {
        let msg;
        try { msg = JSON.parse(ev.data); } catch { return; }
        const h = this.handlers[msg.t];
        if (h) h(msg);
      };
      this.ws = ws;
    });
  }
  send(obj) {
    if (this.ws && this.ws.readyState === 1) this.ws.send(JSON.stringify(obj));
  }
  on(type, fn) { this.handlers[type] = fn; }
  off(type)    { delete this.handlers[type]; }
  close() { try { this.ws?.close(); } catch {} this.ws = null; this.connected = false; }
}

// word length → garbage rows sent to opponent
export function attackForWord(len) {
  if (len >= 7) return 4;
  if (len >= 6) return 3;
  if (len >= 5) return 2;
  if (len >= 4) return 1;
  return 0;
}

// blockers: 7+ letras envían 1; LETRIS legendaria envía 2 extra
export function blockersForWord(len, triggeredLegendary) {
  let n = 0;
  if (len >= 7) n += 1;
  if (triggeredLegendary) n += 2;
  return n;
}

// ELO update (K=32). actual: 1=win, 0=loss, 0.5=draw
export function updateElo(myElo, oppElo, actual) {
  const expected = 1 / (1 + Math.pow(10, (oppElo - myElo) / 400));
  const K = 32;
  const newElo = Math.round(myElo + K * (actual - expected));
  return { newElo, delta: newElo - myElo };
}
